module.exports = __webpack_public_path__ + "assets/img/34_698.db272ccb.jpg";